import { LRUCache } from "lru-cache";
import * as APITypes from "~/API";
import { EMPTY_PROPERTY } from "~/services/server";

export const MAX_CACHE_ITEMS = 1000;
export const MILLI_SECONDS = 1000;

export class PropertyLRUCache {
  private static cache: LRUCache<string, APITypes.Property>;

  public static getCacheInstance() {
    if (PropertyLRUCache.cache) {
      return PropertyLRUCache.cache;
    }

    PropertyLRUCache.cache = new LRUCache<string, APITypes.Property>({
      max: MAX_CACHE_ITEMS,
      ttl: 5 * MILLI_SECONDS,
    });
    return PropertyLRUCache.cache;
  }

  public static get(key: string) {
    PropertyLRUCache.getCacheInstance();

    const value = PropertyLRUCache.cache.get(key);
    if (value === undefined) {
      return {
        success: false,
        data: EMPTY_PROPERTY,
        error: new Error(`entry not found for key: ${key}`),
      };
    }

    return {
      success: true,
      data: value,
    };
  }

  public static update({
    key,
    value,
  }: {
    key: string;
    value: APITypes.Property;
  }) {
    PropertyLRUCache.getCacheInstance();

    PropertyLRUCache.cache.set(key, value);
    return PropertyLRUCache.cache;
  }

  /**
   * Clear the entire cache or a single element in the cache
   *
   * @param key optional: the key for the element to be removed from the cache.
   * If not passed, then entire cache is cleared
   * @returns
   */
  public static clear({ key }: { key?: string }) {
    PropertyLRUCache.getCacheInstance();

    if (key) {
      const isDeleted = PropertyLRUCache.cache.delete(key);
      return {
        success: isDeleted,
        data: PropertyLRUCache.cache,
        error: isDeleted
          ? new Error(`error deleting ${key} from the property cache`)
          : null,
      };
    }

    PropertyLRUCache.cache.clear();
    return {
      success: true,
      data: PropertyLRUCache.cache,
    };
  }
}
